import apiRequest from '../../utils/apiRequest';

const useTemplates = () => {
  const getApiRequest = (endpoint) => {
    return apiRequest('GET', endpoint, null, null, { 'Accept': 'application/json' }).then(data => data.json);
  };

  const Templates = {
    getTemplateTags: function () {
      return new Promise(async (resolve) => {
        const templateTags = await getApiRequest('/api/v1/template_tags');

        resolve(templateTags);
      });
    },
  };

  return { Templates };
};

export default useTemplates;
